import {
  TRACKING_DOMAINS,
  LOCAL_STORAGE_KEY,
  SESSION_STORAGE_KEY,
  REFERRER_STORAGE_KEY,
  VISITOR_ID_PARAM,
} from 'define';
import { getVisitorId } from 'utils/visitorTracking';

export const pushCustomSubmitEvent = formID =>
  window.dataLayer.push({
    event: 'custom_submit_true',
    category: 'custom_submit_true',
    'gtm.elementId': `url: ${window.location.href}; formID: ${formID};`,
  });

export const pushCookiePolicyEvent = () =>
  window.dataLayer.push({
    event: 'cookie_policy_update',
  });

export const pushCustomEvent = (event, options = {}) => {
  window.dataLayer.push({
    event,
    ...options,
  });
};

export const pushWhitePaperEvent = options => pushCustomEvent('ndrsn_whitepaper', options);

export const pushSearchEvent = options => pushCustomEvent('ndrsn_search', options);

export function appendTrackingParams(targetUrl) {
  const url = new URL(targetUrl);

  const attributionSource = [
    sessionStorage.getItem(SESSION_STORAGE_KEY),
    localStorage.getItem(LOCAL_STORAGE_KEY),
  ]
    .filter(Boolean)
    .map(point => new URL(point))
    .find(point => point.search);

  attributionSource?.searchParams.forEach((value, key) => {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  });

  const gclid = localStorage.getItem('gclid');

  if (gclid && !url.searchParams.has('gclid')) {
    url.searchParams.set('gclid', gclid);
  }

  const referrer = localStorage.getItem(REFERRER_STORAGE_KEY);

  if (referrer && !url.searchParams.has('referrer')) {
    url.searchParams.set('referrer', referrer);
  }

  url.searchParams.set(VISITOR_ID_PARAM, getVisitorId());

  return url.toString();
}

export function handleAppendParams(event) {
  if (event.type === 'keydown' && event.key !== 'Enter') {
    return;
  }

  const link = event.target.closest('a');

  if (!link?.href) {
    return;
  }

  const url = new URL(link.href);

  if (!TRACKING_DOMAINS.includes(url.hostname)) {
    return;
  }

  if (url.hostname === window.location.hostname) {
    return;
  }

  link.href = appendTrackingParams(link.href);
}
